/* Keep muted banner/hero videos autoplaying and looping, including Safari. */
(function () {
  var BOUND = 'data-cu-autoplay-bound';
  var RETRIES = 'data-cu-play-tries';

  function ancestorHidden(el) {
    var node = el;
    while (node && node.nodeType === 1) {
      var style = window.getComputedStyle(node);
      if (style.display === 'none' || style.visibility === 'hidden') return true;
      node = node.parentElement;
    }
    return false;
  }

  function wantsAutoplay(video) {
    if (!video || video.nodeName !== 'VIDEO') return false;
    if (video.hasAttribute('autoplay')) return true;
    var host = video.closest('video-media');
    return !!(host && host.hasAttribute('autoplay'));
  }

  function prime(video) {
    video.muted = true;
    video.defaultMuted = true;
    try {
      video.volume = 0;
    } catch (err) {}
    video.setAttribute('muted', '');
    video.setAttribute('autoplay', '');
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', 'webkit-playsinline');
    video.loop = true;
    video.setAttribute('loop', '');
    video.controls = false;
    video.removeAttribute('controls');
    if (video.getAttribute('preload') === 'none') video.setAttribute('preload', 'auto');
    var host = video.closest('video-media');
    if (host) {
      host.setAttribute('autoplay', '');
      host.setAttribute('loaded', '');
      host.removeAttribute('suspended');
      host.removeAttribute('show-play-button');
    }
  }

  function markPlaying(video) {
    var host = video.closest('video-media');
    if (!host) return;
    host.setAttribute('playing', '');
    host.setAttribute('loaded', '');
    host.removeAttribute('suspended');
  }

  function tryPlay(video) {
    if (!wantsAutoplay(video)) return;
    prime(video);
    if (ancestorHidden(video)) {
      if (!video.paused) video.pause();
      return;
    }
    if (!video.paused && !video.ended && video.readyState > 2) {
      markPlaying(video);
      return;
    }
    var playPromise = video.play();
    if (playPromise && typeof playPromise.then === 'function') {
      playPromise.then(function () {
        markPlaying(video);
      }).catch(function () {
        var tries = parseInt(video.getAttribute(RETRIES) || '0', 10);
        if (tries >= 16) return;
        video.setAttribute(RETRIES, String(tries + 1));
        window.setTimeout(function () {
          tryPlay(video);
        }, 350);
      });
    }
  }

  function kickHosts() {
    document.querySelectorAll('video-media[autoplay]').forEach(function (el) {
      try {
        if (typeof el.play === 'function') el.play();
      } catch (err) {}
    });
  }

  function syncAll() {
    document.querySelectorAll('video').forEach(tryPlay);
    kickHosts();
  }

  function onReady(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  onReady(syncAll);
  window.addEventListener('pageshow', syncAll);
  window.addEventListener('focus', syncAll);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) syncAll();
  });
  window.addEventListener('orientationchange', function () {
    window.setTimeout(syncAll, 250);
  });

  ['touchstart', 'pointerdown', 'click', 'scroll', 'wheel'].forEach(function (type) {
    document.addEventListener(type, syncAll, { capture: true, passive: true });
  });

  ['loadedmetadata', 'loadeddata', 'canplay', 'canplaythrough'].forEach(function (type) {
    document.addEventListener(
      type,
      function (event) {
        if (event.target) tryPlay(event.target);
      },
      true
    );
  });

  if (!('IntersectionObserver' in window)) return;

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) tryPlay(entry.target);
      });
    },
    { threshold: 0, rootMargin: '200px 0px' }
  );

  var observeVideos = function () {
    document.querySelectorAll('video').forEach(function (video) {
      if (video.getAttribute(BOUND)) return;
      video.setAttribute(BOUND, 'true');
      io.observe(video);
    });
  };

  onReady(observeVideos);
  if ('MutationObserver' in window) {
    new MutationObserver(observeVideos).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
